import { Button, Text, tokens } from '@fluentui/react-components';
import { ErrorCircle16Regular } from '@fluentui/react-icons';
import { useTranslation } from '../../i18n';

/**
 * What a tile or panel shows when its data failed to load: an error, said as one, with a Retry. Never a zero, a
 * dash or the empty state. The Meetings page's Upcoming tab rendered "no upcoming meetings" on every load from
 * 2026-08-04 to 2026-10-28 because the request failed and nothing on the page read the query's error
 * (Christian, 2026-10-28: "make the dashboard say when a tile fails to load").
 */
export function LoadFailed({ onRetry }: { onRetry?: () => void }) {
  const { t } = useTranslation();
  return (
    <div role="alert" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
      <ErrorCircle16Regular style={{ color: tokens.colorPaletteRedForeground1, flexShrink: 0 }} aria-hidden />
      <Text size={200} style={{ color: tokens.colorPaletteRedForeground1 }}>
        {t('common.loadFailed')}
      </Text>
      {onRetry && (
        <Button size="small" appearance="subtle" onClick={() => onRetry()}>
          {t('common.retry')}
        </Button>
      )}
    </div>
  );
}
